import { createSlice } from '@reduxjs/toolkit';
import { v4 as uuidv4 } from 'uuid';

const initialState = {
  basketData: {
    basketID: uuidv4(),
    startDate: new Date().toISOString(),
    items: [],
    basketItemsQty: 0,
    basketTotalValue: 0,
  },
  basketItemImg: '',
  deliveryData: {
    basketID: '',
    lng: '',
    lat: '',
    formatted_Address: [],
    postcode: '',
    line1: '',
    line2: '',
    line3: '',
    line4: '',
    county: '',
    district: '',
    town_or_city: '',
    residential: '',
    buildingName: '',
  },
  billingData: {
    basketID: '',
    lng: '',
    lat: '',
    formatted_Address: [],
    postcode: '',
    line1: '',
    line2: '',
    line3: '',
    line4: '',
    county: '',
    district: '',
    town_or_city: '',
    residential: '',
    buildingName: '',
  },
  optimoData: {},
  delMethod: 'fitter-van',
  delCost: 0,
  basketOrderValue: 0,
  customerData: {
    fullName: '',
    companyName: '',
    email: '',
    phone: 0,
  },
  payMethod: 'stripe',
};

export const selectBasketItemsQty = (state) =>
  state.basket.basketData.basketItemsQty;

const basketSlice = createSlice({
  name: 'basket',
  initialState,
  reducers: {
    resetBasketState: () => initialState,
    setBasketID: (state, action) => {
      state.basketData.basketID = action.payload;
    },
    setStartDate: (state, action) => {
      state.basketData.startDate = action.payload;
    },
    setName: (state, action) => {
      state.customerData.fullName = action.payload;
    },
    setCompany: (state, action) => {
      state.customerData.companyName = action.payload;
    },
    setEmail: (state, action) => {
      state.customerData.email = action.payload;
    },
    setTel: (state, action) => {
      state.customerData.phone = action.payload;
    },
    setCustomerData: (state, action) => {
      state.customerData = action.payload;
    },
    setItems: (state, action) => {
      state.basketData.items = action.payload;
    },
    setBasketItemsQty: (state, action) => {
      state.basketData.basketItemsQty = action.payload;
    },
    setTotalValue: (state, action) => {
      state.basketData.basketTotalValue = action.payload;
    },
    setBasketItemImg: (state, action) => {
      state.basketItemImg = action.payload;
    },
    setDelMethod: (state, action) => {
      state.delMethod = action.payload;
    },
    setDeliveryData: (state, action) => {
      state.deliveryData = action.payload;
    },
    setBillingData: (state, action) => {
      state.billingData = action.payload;
    },
    setOptimoData: (state, action) => {
      state.optimoData = action.payload;
    },
    setDelCost: (state, action) => {
      state.delCost = action.payload;
    },
    setBasketOrderValue: (state, action) => {
      state.basketOrderValue = action.payload;
    },
    setPayMethod: (state, action) => {
      state.payMethod = action.payload;
    },
    addItemToBasket: (state, action) => {
      const { item } = action.payload;
      state.basketData.items.push(item);
      state.basketData.basketItemsQty++;
    },
    removeItemFromBasket: (state, action) => {
      const itemId = action.payload;
      const index = state.basketData.items.findIndex(
        (item) => item.id === itemId
      );
      if (index !== -1) {
        state.basketData.items.splice(index, 1);
        state.basketData.basketItemsQty--;
      }
    },
    changeItemQuantity: (state, action) => {
      const { itemId, qty } = action.payload;
      const itemIndex = state.basketData.items.findIndex(
        (item) => item.id === itemId
      );
      if (itemIndex !== -1 && qty !== 0) {
        state.basketData.items[itemIndex].qty = Math.max(
          1,
          state.basketData.items[itemIndex].qty + qty
        );
      }
    },
    clearBasket: (state) => {
      state.basketData.items = [];
      state.basketData.basketItemsQty = 0;
    },
    resetDeliveryData: (state) => {
      state.deliveryData = { ...initialState.deliveryData };
    },
    resetBillingData: (state) => {
      state.billingData = { ...initialState.billingData };
    },
    resetOptimoData: (state) => {
      state.optimoData = { ...initialState.optimoData };
    },
    resetDelMethod: (state) => {
      state.delMethod = 'collect';
    },
    resetDelCost: (state) => {
      state.delCost = 0;
    },
    resetBasketOrderValue: (state) => {
      state.basketOrderValue = 0;
    },
    resetName: (state) => {
      state.customerData.fullName = '';
    },
    resetCompany: (state) => {
      state.customerData.companyName = '';
    },
    resetEmail: (state) => {
      state.customerData.email = '';
    },
    resetTel: (state) => {
      state.customerData.phone = 0;
    },
    resetPayMethod: (state) => {
      state.payMethod = 'paymentsense';
    },
  },
});

// Export actions
export const {
  addItemToBasket,
  removeItemFromBasket,
  clearBasket,
  setBasketID,
  setStartDate,
  setItems,
  setName,
  setEmail,
  setCompany,
  setTel,
  setCustomerData,
  changeItemQuantity,
  setBasketItemsQty,
  setBasketItemImg,
  setTotalValue,
  setBasketOrderValue,
  setDeliveryData,
  setOptimoData,
  setBillingData,
  setDelMethod,
  setDelCost,
  setPayMethod,
  resetDeliveryData,
  resetOptimoData,
  resetBillingData,
  resetDelMethod,
  resetName,
  resetEmail,
  resetCompany,
  resetTel,
  resetPayMethod,
  resetBasketState,
} = basketSlice.actions;

// Export the reducer
export default basketSlice.reducer;
